import { Section } from "./Section"
import { Solution } from "./Solution"
import { Partners } from "./Partners"
import { Foerderung } from "./Foerderung"
import { Award, GraduationCap, BadgeQuestionMark, Mail } from "lucide-react"
import { Contact } from "./Contact"

export function SolutionSection() {
  return (
    <Section
      id="loesung"
      eyebrow="Problem"
      Icon={BadgeQuestionMark}
      title="Schulbücher werden selten weitergegeben"
      description="Nach jedem Schuljahr bleiben viele Bücher ungenutzt, obwohl sie im nächsten Jahr erneut gebraucht werden. Der Austausch ist oft
          unstrukturiert oder findet gar nicht statt.">
      <Solution />
    </Section>
  )
}

export function PartnerSection() {
  return (
    <Section
      id="partner"
      eyebrow="Von Schülern für Schüler"
      Icon={GraduationCap}
      title="Gemeinsam mit Schulen entwickelt"
      description="Aus eigener Erfahrung kennen wir die hohen Kosten und den Aufwand rund um Schulbücher. Bookay entsteht im direkten Austausch mit Partnerschulen und
            wird im Schulalltag getestet.">
      <Partners />
    </Section>
  )
}

export function FoerderungSection() {
  return (
    <Section
      id="foerderung"
      eyebrow="Förderung"
      Icon={Award}
      title="Gefördert durch das BMBF"
      description="Bookay wird durch das Bundesministerium für Bildung und Forschung (BMBF) unterstützt. Die Förderung ermöglicht die Entwicklung und
            Erprobung einer digitalen Lösung für den schulischen Schulbuchkreislauf.">
      <Foerderung />
    </Section>
  )
}

export function ContactSection() {
  return (
    <Section
      id="kontakt"
      eyebrow="Kontakt"
      Icon={Mail}
      title="Interesse an Bookay?"
      description="Du möchtest Bookay an deiner Schule einsetzen oder mehr erfahren? Schreib uns. Wir zeigen dir gerne, wie Bookay funktioniert und wie eine Zusammenarbeit mit deiner Schule aussehen kann.">
      <Contact />
    </Section>
  )
}
